import * as Rx from '@radix-ui/react-dropdown-menu';
import { cn } from '../lib/cn';

export const DropdownMenu = Rx.Root;
export const DropdownMenuTrigger = Rx.Trigger;

export function DropdownMenuContent({
  className,
  align = 'end',
  children,
  ...props
}: Rx.DropdownMenuContentProps) {
  return (
    <Rx.Portal>
      <Rx.Content
        align={align}
        sideOffset={6}
        className={cn(
          'z-50 min-w-56 overflow-hidden rounded-xl border border-border bg-surface p-1.5 shadow-pop',
          className,
        )}
        {...props}
      >
        {children}
      </Rx.Content>
    </Rx.Portal>
  );
}

export interface DropdownMenuItemProps extends Rx.DropdownMenuItemProps {
  destructive?: boolean;
  icon?: React.ReactNode;
}

export function DropdownMenuItem({
  className,
  destructive,
  icon,
  children,
  ...props
}: DropdownMenuItemProps) {
  return (
    <Rx.Item
      className={cn(
        'flex cursor-pointer items-center gap-2.5 rounded-lg px-3 py-2 text-sm outline-none',
        'data-[highlighted]:bg-page data-[disabled]:pointer-events-none data-[disabled]:opacity-40',
        destructive ? 'text-danger' : 'text-fg',
        className,
      )}
      {...props}
    >
      {icon && <span className="shrink-0 [&>svg]:h-4 [&>svg]:w-4">{icon}</span>}
      {children}
    </Rx.Item>
  );
}
